<template>
  <v-container 
    fluid 
    fill-height>
    <v-layout 
      align-center 
      justify-center>
      <v-progress-circular 
        v-if="loading"
        :size="50" 
        indeterminate 
        color="primary"/>
      <v-flex 
        v-else 
        xs12 
        sm8 
        md4>
        <v-card 
          class="elevation-12">
          <v-toolbar 
            dark 
            color="primary">
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer/>
            <v-tooltip right>
              <v-btn 
                slot="activator"
                icon 
                large 
                target="_blank" 
              >
                <v-icon large>code</v-icon>
              </v-btn>
              <span>Codepen</span>
            </v-tooltip>
          </v-toolbar>
          <v-form v-if="showForm">
            <v-card-text>
              <v-alert 
                v-if="!loading"
                :value="!!errorCode" 
                type="error">
                {{ errorCode + ': ' + errorMessage }}
              </v-alert>
              <v-progress-circular
                v-if="loading"
                :size="50"
                color="primary"
                indeterminate
              />

              <v-text-field 
                v-model="email"
                prepend-icon="email" 
                name="email" 
                label="Email" 
                type="text"/>
              <v-text-field 
                id="password"
                v-model="password" 
                prepend-icon="lock" 
                name="password" 
                label="Password" 
                type="password"/>                  
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn 
                large
                color="success" 
                @click="signIn">Login</v-btn>   
            </v-card-actions>
          </v-form>
          <v-card-actions>
            <v-btn 
              href="deakin-login/index.php" 
              color="primary">Deakin Login</v-btn>
            <v-spacer/>
            <v-btn 
              color="primary" 
              @click="showForm = true">Organisation</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: "",
    password: "",
    errorCode: null,
    errorMessage: null,
    showForm: false,
    drawer: null,
    nextRoute: { path: "/" }
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined && value !== "") {
        this.$router.push(this.nextRoute);
      }
    }
  },
  created() {
    if (this.$route.query.redirect) {
      this.nextRoute.path = this.$route.query.redirect;
    }
  },
  methods: {
    signIn() {
      this.errorCode = null;
      this.errorMessage = null;
      let self = this;
      this.$store.dispatch("setLoading", true);
      this.$store.state
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(function() {
          // self.$store.dispatch("setLoading", false);
        })
        .catch(function(error) {
          self.$store.dispatch("setLoading", false);
          self.errorCode = error.code;
          self.errorMessage = error.message;
        });
    }
  }
};
</script>
